var _excluded = ["contextFactory"];
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var globalHelper = (target, _ref) => {
  var contextFactory = _ref.contextFactory,
    props = _objectWithoutProperties(_ref, _excluded);
  var _props$tag = props.tag,
    tag = _props$tag === void 0 ? 'provider' : _props$tag,
    _props$debug = props.debug,
    debug = _props$debug === void 0 ? false : _props$debug;
  var log = function log(message) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    return debug && console.log("".concat(tag, ": ").concat(typeof message === 'string' ? message : ''), ...(typeof message === 'string' ? [] : [message]), ...args);
  };
  log('Creating global helper');
  var isMounted = false;
  var updateQueue = [];
  var getState = () => target.state;
  var doUpdate = (newState, after) => {
    log('doUpdate', newState);
    target.setState(newState, () => {
      after();
    });
  };
  var processQueue = () => {
    log('processQueue, length:', updateQueue.length);
    while (updateQueue.length > 0) {
      var entry = updateQueue.shift();
      if (entry) {
        var _entry = _slicedToArray(entry, 2),
          state = _entry[0],
          after = _entry[1];
        doUpdate(state, after);
      }
    }
  };
  var updateContext = function updateContext(newState) {
    var after = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : () => {};
    log('updateContext', newState);
    updateQueue.push([newState, after]);
    if (isMounted) {
      processQueue();
    }
  };
  log('returning default state');
  return {
    buildState: () => {
      log('building default state');
      var state = contextFactory(props, updateContext, getState);
      log('Built state: ', state);
      return state;
    },
    setUp: () => {
      log('setting up context, state is', getState());
      isMounted = true;
      processQueue();
    },
    tearDown: () => {
      log('tearDown');
    }
  };
};
export default globalHelper;